// extracted by mini-css-extract-plugin
export default {"row":"UserPermissionRow_row__sn1ns","label":"UserPermissionRow_label__9F36k"};